import { EditListing } from '../../contexts/EditListingContext';
import { ErrorBoundary } from '../../components/common/ErrorBoundary';
import { EditRouteLoader } from './EditRouteLoader';
import FallbackError from '../../components/common/FallbackError';
import { Box } from '@mui/material';
import EditHeader from '../../components/edit/header/EditHeader';
import { Outlet } from 'react-router-dom';
import { DebugInfoProvider } from '../../contexts/DebugInfoContext';

const EditWrapper = () => {
  return (
    <DebugInfoProvider>
      <EditListing>
        <ErrorBoundary fallback={<FallbackError />}>
          <EditRouteLoader>
            <Layout />
          </EditRouteLoader>
        </ErrorBoundary>
      </EditListing>
    </DebugInfoProvider>
  );
};

const Layout = () => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <EditHeader />
      <Outlet />
    </Box>
  );
};

export default EditWrapper;
